import AuthCard from 'components/Auth/Card'
import SignInForm from 'components/Auth/SignInForm'
import React from 'react'

function SignIn() {
  return (
    <AuthCard title="Welcome back" desc="Please provide your credentials to login." >
      <SignInForm />
    </AuthCard>
  )
}

export default SignIn